import React from "react";
import { useLang } from "../context/LanguageContext";

const StatsBar = () => {
  const { t } = useLang();
  const items = t("stats.items");
  return (
    <section className="bg-[#FF5C00]">
      <div className="max-w-[1200px] mx-auto px-6 py-7">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {items.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-[32px] md:text-[38px] font-extrabold text-white leading-none">{s.value}</div>
              <div className="mt-2 text-[11px] md:text-[12px] font-medium tracking-[0.14em] uppercase text-white/80">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
